import React from "react";
import { useTranslation } from "react-i18next";
import { getCreatividadLabels } from "../utils/creatividadesLabels";
import styles from "../styles/encuesta4c.module.css";

function CreatividadNombre({ creatividad, variant = "card" }) {
  const { t } = useTranslation();
  const { nombreNuevo, nombreAntiguo } = getCreatividadLabels(creatividad, t);
  const nameClass = variant === "hero" ? styles.creatHeroName : styles.creatCardName;

  return (
    <div className={styles.creatNameBlock}>
      <span className={nameClass}>{nombreNuevo}</span>
      {nombreAntiguo ? (
        <span className={styles.creatLegacyName}>{nombreAntiguo}</span>
      ) : null}
    </div>
  );
}

export default CreatividadNombre;
